import {
  FETCH_VIVIENDAS,
  CLEAR_VIVIENDAS_ACTION,
  SEND_VIVIENDA,
  FETCH_SUBCONDOMINIOS,
  FETCH_DESARROLLOS,
  FETCH_VIVIENDA_INFO,
  ASOCIATE_RESIDENT,
  DELETE_ASOC_ACTION,
  DELETE_ASOC_VEHICLE_ACTION,
  DELETE_VIVIENDA,
} from './actions.type';

import {
  CLEAR_VIVIENDAS,
  SET_VIVIENDAS,
  SUBMITED_VIVIENDA,
  SUBMIT_VIVIENDA_ERROR,
  RESET_VIVIENDA_SUBMIT,
  FETCHING_VIVIENDAS,
  FETCHED_VIVIENDAS,
  SET_ERROR,
  SET_SUBCONDOMINIOS,
  SET_DESARROLLOS,
  CLEAR_VIVIENDA_INFO,
  SET_VIVIENDA,
  FETCHED_VIVIENDA,
  FETCHING_VIVIENDA,
  SUBMIT_RESIDENT_ASOC_ERROR,
  SUBMITED_RESIDENT_ASOC,
  SUBMITING_RESIDENT_ASOC,
  RESET_RESIDENT_ASOC_SUBMIT, DELETED_ASOC,
} from './mutations.type';
import ApiService from '../common/api.service';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  viviendas_list: [],
  desarrollos_list: [],
  subcondominios_list: [],
  loading_viviendas: false,
  submited_vivienda: false,
  vivienda_info: {},
  loading_vivienda: false,
  submiting_resident_asoc: false,
  submited_resident_asoc: false,
};

const getters = {
  is_loading_viviendas() {
    return state.loading_viviendas;
  },
  viviendas_list() {
    return state.viviendas_list;
  },
  subcondominios_list() {
    return state.subcondominios_list;
  },
  desarrollos_list() {
    return state.desarrollos_list;
  },
  vivienda_submited() {
    return state.submited_vivienda;
  },
  vivienda_info() {
    return state.vivienda_info;
  },
  submited_resident_asoc() {
    return state.submited_resident_asoc;
  },
  submiting_resident_asoc() {
    return state.submiting_resident_asoc;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
};

const actions = {
  [DELETE_VIVIENDA](context, viviendaId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post(`accesos/delete_vivienda/${viviendaId}`)
        .then(({ data }) => {
          context.commit(SUBMITED_VIVIENDA, data);
          resolve(data);
          context.dispatch(FETCH_VIVIENDAS);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_VIVIENDA_ERROR, [response.data.message]);
        });
    });
  },
  [SEND_VIVIENDA](context, data) {
    return new Promise((resolve) => {
      const viviendaId = data.get('vivienda_id');
      let url = 'accesos/viviendas';
      if (typeof viviendaId !== 'undefined') {
        url = `accesos/viviendas/${viviendaId}`;
      }
      ApiService.setHeader();
      ApiService.post(url, data)
        .then(({ data }) => {
          console.log(data);
          context.commit(SUBMITED_VIVIENDA, data);
          resolve(data);
          context.commit(CLEAR_VIVIENDA_INFO);
          context.dispatch(FETCH_VIVIENDAS);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SUBMIT_VIVIENDA_ERROR, [response.data.message]);
        });
    });
  },
  [ASOCIATE_RESIDENT](context, data) {
    context.commit(RESET_RESIDENT_ASOC_SUBMIT);
    const viviendaId = data.vivienda_id;
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(SUBMITING_RESIDENT_ASOC);
      const toSend = {
        vivienda_id: data.vivienda_id,
        residente_id: data.residente_id,
        puede_autorizar: data.puede_autorizar,
        propietario: data.propietario,
        propietario_residente: data.propietario_residente,
        residente_inquilino: data.residente_inquilino,
      };
      ApiService.post('accesos/add_resident_to_residence', toSend)
        .then(({ data }) => {
          context.commit(SUBMITED_RESIDENT_ASOC);
          resolve(data);
          context.dispatch(FETCH_VIVIENDA_INFO, viviendaId);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_RESIDENT_ASOC_ERROR, [response.data.message]);
        });
    });
  },
  [DELETE_ASOC_ACTION](context, data) {
    const viviendaId = data.vivienda_id;
    return new Promise((resolve) => {
      ApiService.setHeader();
      const toSend = {
        vivienda_id: data.vivienda_id,
        residente_id: data.residente_id,
      };
      ApiService.post('accesos/remove_resident_from_residence', toSend)
        .then(({ data }) => {
          context.commit(DELETED_ASOC);
          resolve(data);
          context.dispatch(FETCH_VIVIENDA_INFO, viviendaId);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_RESIDENT_ASOC_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_VIVIENDAS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_VIVIENDAS);
      ApiService.query('accesos/viviendas')
        .then(({ data }) => {
          context.commit(SET_VIVIENDAS, data);
          context.commit(FETCHED_VIVIENDAS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_VIVIENDAS);
        });
    });
  },
  [FETCH_SUBCONDOMINIOS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.query('accesos/subcondominios')
        .then(({ data }) => {
          context.commit(SET_SUBCONDOMINIOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_DESARROLLOS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.query('accesos/desarrollos')
        .then(({ data }) => {
          context.commit(SET_DESARROLLOS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_VIVIENDA_INFO](context, viviendaId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_VIVIENDA);
      context.commit(CLEAR_VIVIENDA_INFO);
      const url = `accesos/viviendas/${viviendaId}`;
      ApiService.query(url)
        .then(({ data }) => {
          context.commit(SET_VIVIENDA, data);
          context.commit(FETCHED_VIVIENDA);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_VIVIENDA);
        });
    });
  },
  [CLEAR_VIVIENDAS_ACTION](context) {
    context.commit(CLEAR_VIVIENDAS);
  },
  [DELETE_ASOC_VEHICLE_ACTION](context, data) {
    const viviendaId = data.vivienda_id;
    return new Promise((resolve) => {
      ApiService.setHeader();
      const toSend = {
        vivienda_id: data.vivienda_id,
        vehiculo_id: data.vehiculo_id,
      };
      ApiService.post('accesos/remove_vehicle_from_residence', toSend)
        .then(({ data }) => {
          context.commit(DELETED_ASOC);
          resolve(data);
          context.dispatch(FETCH_VIVIENDA_INFO, viviendaId);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_RESIDENT_ASOC_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [CLEAR_VIVIENDAS](state) {
    state.viviendas_list = [];
  },
  [SET_VIVIENDAS](state, data) {
    state.viviendas_list = data.viviendas;
  },
  [SET_DESARROLLOS](state, data) {
    state.desarrollos_list = data.desarrollos;
  },
  [SET_SUBCONDOMINIOS](state, data) {
    state.subcondominios_list = data.subcondominios;
  },
  [SUBMITED_VIVIENDA](state, data) {
    state.submited_vivienda = true;
    state.alert = true;
    if (data.code !== 0) {
      state.alertType = 'error';
      state.alertMessage = data.message;
    } else {
      state.alertType = 'success';
      state.alertMessage = data.message;
    }
  },
  [DELETED_ASOC](state) {
    state.alert = true;
    state.alertMessage = 'Residente Desvinculado Correctamente';
    state.alertType = 'success';
  },
  [SUBMIT_VIVIENDA_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
  [SUBMITED_RESIDENT_ASOC](state) {
    state.alert = true;
    state.alertMessage = 'Residente Asociado Correctamente';
    state.alertType = 'success';
    state.submiting_resident_asoc = false;
    state.submited_resident_asoc = true;
  },
  [SUBMIT_RESIDENT_ASOC_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
    state.submiting_resident_asoc = false;
  },
  [RESET_VIVIENDA_SUBMIT](state) {
    state.submited_vivienda = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [RESET_RESIDENT_ASOC_SUBMIT](state) {
    state.submited_resident_asoc = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [FETCHING_VIVIENDAS](state) {
    state.loading_viviendas = true;
  },
  [FETCHED_VIVIENDAS](state) {
    state.loading_viviendas = false;
  },
  [CLEAR_VIVIENDA_INFO](state) {
    state.vivienda_info = {};
  },
  [SET_VIVIENDA](state, data) {
    state.vivienda_info = data.vivienda;
  },
  [FETCHING_VIVIENDA](state) {
    state.loading_vivienda = true;
  },
  [FETCHED_VIVIENDA](state) {
    state.loading_vivienda = false;
  },
  [SUBMITING_RESIDENT_ASOC](state) {
    state.submiting_resident_asoc = true;
  },
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
